var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "form-group"]
var hoisted5 = ["for", "ref"]
var hoisted6 = ["id", "ref", "class", "form-control input-sm"]
var __target

module.exports = function description (model, root) {
  elementOpen("div", "8f67050c-1287-4c99-aa2a-361f55744632", hoisted1)
    elementOpen("div")
      elementOpen("label", "f9f9a378-484b-4cda-99c2-664391536947", hoisted2)
        elementOpen("input", "5289d3f8-b382-44ef-a9be-c79b51ae3803", hoisted3, "checked", model.required, "onchange", function ($event) {
          var $element = this;
        model.required = this.checked})
        elementClose("input")
        text(" Required \
              ")
      elementClose("label")
    elementClose("div")
  elementClose("div")
  elementOpen("div", "9a77c470-0e69-473e-9d13-82adde04fc20", hoisted4)
    elementOpen("label", "870a2234-754a-4d42-83e6-3596ce8991ce", hoisted5)
      text("Ref")
    elementClose("label")
    elementOpen("select", "f5957847-f904-47d3-8ddb-9e15a702b062", hoisted6, "value", model.ref, "onchange", function ($event) {
      var $element = this;
    model.ref = this.value})
      elementOpen("option")
      elementClose("option")
      __target = root.availableDocumentRefs()
      if (__target) {
        ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
          var schema = $value
          var $key = "c48c53de-373c-4d9f-8b2e-c3d99e5dc90f_" + $item
          elementOpen("option", $key, null, "value", schema.id, "selected", model.ref === schema.id ? 'selected' : null)
            text("" + (schema.name) + "")
          elementClose("option")
        }, this)
      }
    elementClose("select")
  elementClose("div")
}
